module.exports = __webpack_public_path__ + "ba8c162a35a3b1cc560a16ca671d1203.svg";